module.exports={"Star Rating":"Classificação por Estrelas","# star(s)":"{currentRating, plural, =1{# estrela} other{# estrelas}}"};